import { render, staticRenderFns } from "./c-porcentagem.vue?vue&type=template&id=1aa2867f&scoped=true"
import script from "./c-porcentagem.vue?vue&type=script&lang=js"
export * from "./c-porcentagem.vue?vue&type=script&lang=js"
import style0 from "./c-porcentagem.vue?vue&type=style&index=0&id=1aa2867f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2867f",
  null
  
)

export default component.exports